export default __webpack_public_path__ + "static/media/archive-tool.c5c58152.svg";